import { useDownloadAppModal } from '@/common/DownloadAppModal';
import ListItem from '@/common/ListItem';
import SectionList from '@/common/SectionList';
import Button from '@/components/Button';
import Text from '@/components/Text';

function TournamentsFaq() {
  const { openModal } = useDownloadAppModal();
  const handleDownloadApp = () => {
    openModal();
  };
  return (
    <SectionList title="How tournaments work" isTranslucent isCondensed className="my-0">
      <a id="how-it-works" />
      <ListItem
        className="gap-4 w-full"
        icon={
          <Text size="2xl" className="mx-2">
            1
          </Text>
        }
      >
        <ListItem.Left className="!flex-1 w-full">
          <div className="flex flex-col gap-y-0.5  w-full">
            <Text size="sm">Join a Tournament</Text>
            <Text size="xs" className="text-secondary">
              Jump into an upcoming competition and start building your portfolio.
            </Text>
          </div>
        </ListItem.Left>
      </ListItem>
      <ListItem
        className="gap-4"
        icon={
          <Text size="2xl" className="mx-2">
            2
          </Text>
        }
      >
        <ListItem.Left>
          <div className="flex flex-col gap-y-0.5 ">
            <Text size="sm">Build Your Portfolio</Text>
            <Text size="xs" className="text-secondary">
              Pick stocks & ETFs. Fractional shares only.
            </Text>
          </div>
        </ListItem.Left>
      </ListItem>
      <ListItem
        className="gap-4"
        icon={
          <Text size="2xl" className="mx-2">
            3
          </Text>
        }
      >
        <ListItem.Left>
          <div className="flex flex-col gap-y-0.5 ">
            <Text size="sm">Play Smart</Text>
            <Text size="xs" className="text-secondary">
              No more than 50% in a single stock.
            </Text>
          </div>
        </ListItem.Left>
      </ListItem>
      <ListItem
        className="gap-4"
        icon={
          <Text size="2xl" className="mx-2">
            4
          </Text>
        }
      >
        <ListItem.Left>
          <div className="flex flex-col gap-y-0.5 ">
            <Text size="sm">Watch It Grow</Text>
            <Text size="xs" className="text-secondary">
              Track your performance in real time and climb the leaderboard.
            </Text>
          </div>
        </ListItem.Left>
      </ListItem>
      <ListItem
        className="gap-4"
        icon={
          <Text size="2xl" className="mx-2">
            5
          </Text>
        }
      >
        <ListItem.Left className="flex-auto md:flex-none w-full md:w-auto">
          <div className="flex items-center gap-4 lg:gap-6 justify-between flex-auto">
            <div className="flex flex-col gap-y-0.5 md:flex-auto">
              <Text size="sm">
                Win Rewards{' '}
                <Text size="xs" className="ml-1">
                  🚀
                </Text>
              </Text>
              <Text size="xs" className="text-secondary">
                Earn oinks and redeem them for free stock inside the app.
              </Text>
            </div>
            <div className="flex-none">
              <Button type="Primary" size="xs" onClick={handleDownloadApp}>
                Download App
              </Button>
            </div>
          </div>
        </ListItem.Left>
      </ListItem>
      <ListItem
        className="gap-4"
        icon={
          <Text size="2xl" className="mx-2">
            6
          </Text>
        }
      >
        <ListItem.Left>
          <div className="flex flex-col gap-y-0.5 ">
            <Text size="sm">Top the Leaderboard</Text>
            <Text size="xs" className="text-secondary">
              Highest return wins. Ties go to whoever joined first.
            </Text>
          </div>
        </ListItem.Left>
      </ListItem>
    </SectionList>
  );
}

export default TournamentsFaq;
